import { render, staticRenderFns } from "./CompositeCategory.vue?vue&type=template&id=39ba00ac&scoped=true"
import script from "./CompositeCategory.vue?vue&type=script&lang=js"
export * from "./CompositeCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ba00ac",
  null
  
)

export default component.exports